import normalizeApiError from '../utils/apiError';

import { engineApi } from './api';

export const getProviders = async () => {
  try {
    const { data } = await engineApi.get('/providers/logos');
    return { success: true, data: data.data || [] };
  } catch (error) {
    return normalizeApiError(error, {
      context: 'getting providers',
      fallbackMessage: 'No pudimos cargar las entidades financieras. Intentá nuevamente.'
    });
  }
};
